(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(30441);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 30441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _store_useDidomiNoticeStore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26107);
/* harmony import */ var _components_templates_PageFeedTemplate__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21762);
/* harmony import */ var _hooks_useAdPageName__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97276);
/* harmony import */ var _components_organisms_AdCompanion__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88452);
/* harmony import */ var _firebase_remoteConfig__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8472);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_7__);
/* eslint-disable react/destructuring-assignment */ /* eslint-disable react/prop-types */ 









var DECATHLON_TOKEN = "5e5c3e4c229dfe3590a5f184c4ba0e1da00f0091";
var HomePage = function(props) {
    var getAdPageName = (0,_hooks_useAdPageName__WEBPACK_IMPORTED_MODULE_4__/* .useAdPageName */ .l)().getAdPageName;
    var pageName = getAdPageName();
    var isNoticeReady = (0,_store_useDidomiNoticeStore__WEBPACK_IMPORTED_MODULE_2__/* .useDidomiNoticeStore */ .p)(function(state) {
        return state.isNoticeReady;
    });
    var isProductionENV = "prod" === "prod";
    var headTags = props.tagScriptsData.headTags.map(function(tag) {
        if (tag.attributes.tagType === "favicon") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
            rel: "icon",
            href: String(tag.attributes.tagSource)
        });
        if (tag.attributes.tagType === "script") {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                id: tag.attributes.tagId ? tag.attributes.tagId : String(tag.id),
                dangerouslySetInnerHTML: {
                    __html: tag.attributes.Tag ? tag.attributes.Tag : ""
                },
                src: tag.attributes.tagSource ? tag.attributes.tagSource : undefined,
                async: tag.attributes.async ? tag.attributes.async : undefined,
                defer: tag.attributes.defer ? tag.attributes.defer : undefined,
                crossOrigin: tag.attributes.crossOrigin ? tag.attributes.crossOrigin : undefined
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: tag.attributes.tagClass ? tag.attributes.tagClass : "",
            id: tag.attributes.tagId ? tag.attributes.tagId : "",
            dangerouslySetInnerHTML: {
                __html: tag.attributes.Tag ? tag.attributes.Tag : ""
            }
        });
    });
    var bodyTags = props.tagScriptsData.bodyTags.map(function(tag) {
        if (tag.attributes.tagType === "favicon") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
            rel: "icon",
            href: String(tag.attributes.tagSource)
        });
        if (tag.attributes.tagType === "script") {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_7___default()), {
                id: tag.attributes.tagId ? tag.attributes.tagId : String(tag.id),
                dangerouslySetInnerHTML: {
                    __html: String(tag.attributes.Tag)
                },
                src: tag.attributes.tagSource ? tag.attributes.tagSource : undefined,
                async: tag.attributes.async ? tag.attributes.async : undefined,
                defer: tag.attributes.defer ? tag.attributes.defer : undefined,
                crossOrigin: tag.attributes.crossOrigin ? tag.attributes.crossOrigin : undefined
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: tag.attributes.tagClass ? tag.attributes.tagClass : "",
            id: tag.attributes.tagId ? tag.attributes.tagId : "",
            dangerouslySetInnerHTML: {
                __html: tag.attributes.Tag ? tag.attributes.Tag : ""
            }
        });
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            isNoticeReady && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_organisms_AdCompanion__WEBPACK_IMPORTED_MODULE_5__/* .AdsSetup */ .Qq, {
                getRemoteConfigValue: _firebase_remoteConfig__WEBPACK_IMPORTED_MODULE_6__/* .getRemoteConfigValue */ .I_,
                pageId: 1878515,
                pageName: pageName
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Fangol.pl - Piłka w skr\xf3cie"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "Fangol.pl - piłka w skr\xf3cie. Newsy, memy i relacje z mecz\xf3w. Przeglądaj codziennie aktualności ze świata futbolu. Oceniaj i komentuj wrzuty, głosuj w ankietach, rozwiązuj nieprzeciętne piłkarskie quizy."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "convertiser-verification",
                        content: DECATHLON_TOKEN
                    }),
                    headTags,
                    !isProductionENV && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "noindex"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_templates_PageFeedTemplate__WEBPACK_IMPORTED_MODULE_3__/* .PageFeedTemplate */ .X, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, props), {
                showFilterPanel: true
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: bodyTags
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (HomePage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5523,7725,6473,5796,246,1762,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);